// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hf2o","fullView":"styles_fullView__275By"};